import * as React from 'react';

import {Button} from '../button/button';
import {Card} from '../card/card';
import {colors} from '../colors/colors';
import {ChevronDownIcon} from '../icon';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

import {Checkbox} from './checkbox';

type Props = {
    children: React.ReactNode;
    header: string;
    subHeader: string;
    isChecked: boolean;
    setIsChecked: (isChecked: boolean) => void;
};

export function CheckboxWithAdditionalDetails(props: Props) {
    const [isHovered, setIsHovered] = React.useState<boolean>(false);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    return (
        <Card hasBorder={true} fitHeight={true}>
            <div className='flex pad-16 align-center justify-sb'>
                <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                    <Checkbox
                        label={null}
                        checked={props.isChecked}
                        onChange={props.setIsChecked}
                    />
                    <StackLegacy spacing={2}>
                        <Body color='plum' size='small'>
                            {props.header}
                        </Body>
                        <Body color='plum' size='large' isBold={true}>
                            {props.subHeader}
                        </Body>
                    </StackLegacy>
                </StackLegacy>
                <div
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <Button
                        variant='text'
                        size='small'
                        preventUnderline={true}
                        noPadding={true}
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                            <Body color={isHovered ? 'blue-dk' : 'blue'} underline={isHovered}>
                                {isOpen ? 'Hide details' : 'See details'}
                            </Body>
                            <ChevronDownIcon
                                size={16}
                                style={{color: isHovered ? colors.greyDk : colors.grey}}
                            />
                        </StackLegacy>
                    </Button>
                </div>
            </div>
            {isOpen && props.children}
        </Card>
    );
}
